import { Component } from '@angular/core';

@Component({
  selector: 'uni-box-content-header',
  templateUrl: './uni-box-content-header.component.html',
  styleUrls: ['./uni-box-content-header.component.scss'],
})
export class UniBoxContentHeaderComponent {
}
